import { createRef, Component } from "react";

import DataTable from "components/DigiHapi/DataTable";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import MenuItem from "@mui/material/MenuItem";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

// DigiHapi components
import Activity from "components/DigiHapi/Activity";
import ConfirmDialog from "components/DigiHapi/ConfirmDialog";
import FormSelect from "components/DigiHapi/FormSelect";
import Notification from "components/DigiHapi/Notification";
import FormModal from "components/DigiHapi/FormModal";
import ImageUpload from "components/CustomUpload/ImageUpload";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
	fetchGetCachedImages,
	fetchStoreCachedImage,
	fetchDeleteImage
} from "actions";

import {
	SET_IMAGE_NAME,
	SET_IMAGE_TYPE,
	SET_SUBFOLDER_IMAGES,
	CLEAR_UPLOAD_FILE_VALIDATE,
	VALIDATE_UPLOAD_FILE,
	SET_FILES_IMAGES,
	REMOVE_IMAGE
} from "actions/types.js";

class AddCachedImage extends Component {
	constructor(props) {
		super(props);
		this.child = createRef();
		this.state = {
			br: false
		};
	}

	componentDidUpdate(prevProps, prevState) {
		const { uploadImageResult } = this.props;

		if (uploadImageResult && !prevProps.uploadImageResult) {
			if (this.child.current) {
				//Remove picture
				this.child.current.handleRemove();
			}

			// Display success message
			this.setState({
				br: true
			});
			setTimeout(
				function () {
					this.setState({ br: false });
				}.bind(this),
				6000
			);
		}
	}

	onImageLoaded = (name, imagePreviewUrl) => {
		const { dispatch } = this.props;
		dispatch({
			type: SET_FILES_IMAGES,
			payload: [{ name, base64: imagePreviewUrl }]
		});
	};

	onImageRemoved = () => {
		this.props.dispatch({
			type: REMOVE_IMAGE
		});
	};

	// fetchUploadImages = e => {
	//   e.preventDefault();
	//   const { fetchStoreCachedImage, name, subFolderName, files } = this.props;
	//   fetchStoreCachedImage({ name, subFolderName, files, type });
	// };

	render() {
		const {
			dispatch,
			name,
			type,
			types,
			subFolderName,
			isFetching,
			onClose,
			onClickAdd
		} = this.props;

		return (
			<Grid item xs={12}>
				<FormModal maxWidth="md">
					<Card>
						<MDBox
							mx={2}
							mt={-3}
							py={2}
							px={2}
							variant="gradient"
							bgColor="primary"
							borderRadius="lg"
							coloredShadow="primary"
							display="inline-block"
						>
							<MDTypography variant="h6" color="white">
								{"Ajout d'une image de cache"}
							</MDTypography>
						</MDBox>
						<MDBox p={2}>
							{isFetching ? (
								<Activity />
							) : (
								<Grid container spacing={3} justifyContent="center">
									<Grid item xs={12} sm={4}>
										<MDTypography component="div" variant="h6" mb={1}>
											Image *
										</MDTypography>
										<ImageUpload
											onImageLoaded={this.onImageLoaded}
											onImageRemoved={this.onImageRemoved}
										/>
									</Grid>
									<Grid item xs={12}>
										<MDInput
											label="Nom"
											id="name"
											fullWidth
											type="text"
											autoComplete="off"
											value={name || ""}
											onChange={e =>
												dispatch({
													type: SET_IMAGE_NAME,
													payload: e.target.value
												})
											}
										/>
									</Grid>
									<Grid item xs={12}>
										<FormSelect
											label="Type *"
											value={types[type]}
											onChange={e =>
												dispatch({
													type: SET_IMAGE_TYPE,
													payload: e.target.value
												})
											}
										>
											{Object.values(types).map(item => (
												<MenuItem key={item.type} value={item}>
													{item.label}
												</MenuItem>
											))}
										</FormSelect>
									</Grid>
									<Grid item xs={12}>
										<MDInput
											label="Sous dossier"
											id="subfolder"
											fullWidth
											type="text"
											autoComplete="off"
											value={subFolderName || ""}
											onChange={e =>
												dispatch({
													type: SET_SUBFOLDER_IMAGES,
													payload: e.target.value
												})
											}
										/>
									</Grid>
								</Grid>
							)}
						</MDBox>
						<MDBox p={2} display="flex" justifyContent="flex-end" gap={1}>
							<MDButton variant="outlined" color="secondary" onClick={onClose}>
								Annuler
							</MDButton>
							<MDButton variant="gradient" color="primary" onClick={onClickAdd}>
								<Icon>add</Icon>
								&nbsp;Ajouter
							</MDButton>
						</MDBox>
					</Card>
				</FormModal>
				<Notification
					place="br"
					color="info"
					message="Votre image a été correctement téléversée."
					open={this.state.br}
					onClose={() => this.setState({ br: false })}
				/>
			</Grid>
		);
	}
}

class CachedImagesPage extends Component {
	state = {
		br: false,
		color: "info",
		message: null,
		component: null,
		imageToDelete: null
	};

	componentDidMount() {
		this.props.fetchGetCachedImages();
	}

	componentDidUpdate(prevProps, prevState) {
		const {
			dispatch,
			fetchGetCachedImages,
			fetchStoreCachedImage,
			files,
			subFolderName,
			name,
			type,
			snackErrorMsg,
			snackInfoMsg,
			clearValidate,
			isValid
		} = this.props;

		if (snackErrorMsg && prevProps.snackErrorMsg !== snackErrorMsg) {
			this.autoCloseMessage();
		}

		if (snackInfoMsg && prevProps.snackInfoMsg !== snackInfoMsg) {
			this.setState({
				component: null
			});
			fetchGetCachedImages();
			this.autoCloseMessage();
		}

		if (clearValidate && !prevProps.clearValidate) {
			dispatch({
				type: VALIDATE_UPLOAD_FILE
			});
		}

		if (isValid && !prevProps.isValid) {
			fetchStoreCachedImage({
				files,
				subFolderName,
				name,
				type
			});
		}
	}

	hideAlert = () => {
		this.setState({
			br: false
		});
	};

	autoCloseMessage = () => {
		const { snackErrorMsg, snackInfoMsg } = this.props;

		this.setState({
			br: true,
			message: snackInfoMsg ? snackInfoMsg : snackErrorMsg,
			color: snackInfoMsg ? "info" : "danger"
		});

		if (snackInfoMsg) {
			setTimeout(this.hideAlert, 5000);
		}
	};

	delete = id => {
		this.setState({ imageToDelete: id });
	};

	onClose = () => {
		this.setState({
			component: null
		});
	};

	clearUploadFileValidate = e => {
		e.preventDefault();
		this.props.dispatch({
			type: CLEAR_UPLOAD_FILE_VALIDATE
		});
	};

	addComponent = () => {
		this.setState({
			component: (
				<ConnectedAddCachedImage
					onClose={this.onClose}
					onClickAdd={this.clearUploadFileValidate}
				/>
			)
		});
	};

	getRoundButtons = id => {
		return [{ color: "error", icon: "delete", onClick: this.delete }].map(
			(prop, key) => (
				<MDButton
					variant="gradient"
					size="small"
					circular
					iconOnly
					color={prop.color}
					disabled={!!this.state?.component}
					key={key}
					onClick={() => prop.onClick(id)}
				>
					<Icon>{prop.icon}</Icon>
				</MDButton>
			)
		);
	};

	getCachedImages = () => {
		const { cachedImages, types } = this.props;

		let cachedImagesObj = [];

		if (cachedImages) {
			cachedImagesObj = cachedImages.map(({ _id, name, type, uri }) => {
				return {
					name,
					type: types[type].label,
					uri: (
						<MDBox
							component="img"
							src={uri}
							alt={name}
							width="30px"
							height="30px"
						/>
					),
					actions: (
						<MDBox display="flex" justifyContent="flex-end">
							{this.getRoundButtons(_id)}
						</MDBox>
					)
				};
			});
		}

		return cachedImagesObj;
	};

	render() {
		const { color, message, component, imageToDelete } = this.state;
		const { isFetchingList, fetchDeleteImage } = this.props;

		const columns = [
			{
				Header: "Nom",
				accessor: "name",
				sortable: true,
				filterable: false
			},
			{
				Header: "Image",
				accessor: "uri",
				sortable: false,
				filterable: false
			},
			{
				Header: "Type",
				accessor: "type",
				sortable: true,
				filterable: false
			},
			{
				Header: "Actions",
				accessor: "actions",
				sortable: false,
				filterable: false
			}
		];

		return (
			<Grid container spacing={3} justifyContent="center">
				<Grid item xs={12}>
					<Card>
						<MDBox
							mx={2}
							mt={-3}
							py={2}
							px={2}
							variant="gradient"
							bgColor="primary"
							borderRadius="lg"
							coloredShadow="primary"
							display="flex"
							alignItems="center"
							color="white"
						>
							<Icon>image</Icon>
							<MDTypography variant="h6" color="white" ml={1.5}>
								{"Images"}
							</MDTypography>
						</MDBox>
						<MDBox p={2}>
							<DataTable
								data={this.getCachedImages()}
								filterable
								columns={columns}
								loading={isFetchingList}
								defaultPageSize={5}
								showPaginationTop
								showPaginationBottom={false}
								previousText="Précédent"
								nextText="Suivant"
								rowsText="Lignes"
								noDataText="Aucunes images téléversées"
								ofText="sur"
								loadingText="Chargement..."
							/>
						</MDBox>
						<MDBox p={2} display="flex" justifyContent="flex-end" gap={1}>
							<MDButton
								variant="gradient"
								color="primary"
								onClick={this.addComponent}
								disabled={!!component}
							>
								<Icon>add</Icon>
								&nbsp;Ajout d'une image
							</MDButton>
						</MDBox>
					</Card>
				</Grid>
				{component}
				<ConfirmDialog
					open={!!imageToDelete}
					message="Êtes-vous sûr de vouloir supprimer l'image ?"
					confirmText="Supprimer"
					onCancel={() => this.setState({ imageToDelete: null })}
					onConfirm={() => {
						fetchDeleteImage(imageToDelete);
						this.setState({ imageToDelete: null });
					}}
				/>
				<Notification
					place="br"
					color={color}
					message={message}
					open={this.state.br}
					onClose={this.hideAlert}
				/>
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const {
		isFetchingList,
		isFetching,
		cachedImages,
		snackInfoMsg,
		snackErrorMsg,
		clearValidate,
		isValid,
		files,
		name,
		type,
		types,
		subFolderName,
		nameErrorMsg,
		imageErrorMsg
	} = state.uploadReducer;

	return {
		isFetchingList,
		isFetching,
		cachedImages,
		snackInfoMsg,
		snackErrorMsg,
		clearValidate,
		isValid,
		files,
		name,
		type,
		types,
		subFolderName,
		nameErrorMsg,
		imageErrorMsg
	};
};

const mapDispatchToProps = dispatch => {
	let actions = bindActionCreators(
		{
			fetchStoreCachedImage,
			fetchGetCachedImages,
			fetchDeleteImage
		},
		dispatch
	);
	return { ...actions, dispatch };
};

const ConnectedAddCachedImage = connect(
	mapStateToProps,
	mapDispatchToProps
)(AddCachedImage);

export default {
	CachedImagesPage: connect(
		mapStateToProps,
		mapDispatchToProps
	)(CachedImagesPage),
	AddCachedImage: ConnectedAddCachedImage
};
